import { Link } from "@mui/material"
import { Link as RouterLink, useSearchParams } from "react-router-dom"
import { cleanState } from "routes/schedule/components/schedule-breadcrumbs"

// One ancestor crumb in the share-recipient breadcrumb trail, rendered inside the page header's
// breadcrumbs. Links to the same facilities route with the `id` search param set to this folder, so
// clicking drills the browse to it (the param ShareRegimeSelector reads) and stays inside the share view.
// Receives the resolved id + label so it needs no tree-refreshing hooks.
export function ShareBreadcrumbItem({ id, label }) {
    const [searchParams] = useSearchParams()
    const next = new URLSearchParams(searchParams)
    next.set("id", id)

    return (
        <Link
            component={RouterLink}
            to={`?${next.toString()}`}
            underline="hover"
            data-cy={`share-breadcrumb-${id}`}
            sx={{ color: "text.secondary", fontSize: 13 }}
        >
            {cleanState(label)}
        </Link>
    )
}
